import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Detects BLOCK-level markdown worth a full-width rendered card: a GFM pipe table
 * (header row + delimiter row) or a heading. This is a LAYOUT decision only — short
 * conversational answers stay ordinary bubbles (still markdown-rendered, so inline
 * emphasis displays properly); matches leave the bubble form so tables get room.
 */
export const containsBlockMarkdown = (text) => {
  const s = (text ?? '').toString();
  const hasTable = /(^|\n)\s*\|.+\|\s*\r?\n\s*\|[\s:|-]+\|/.test(s);
  const hasHeading = /(^|\n)#{1,6}\s+\S/.test(s);
  return hasTable || hasHeading;
};

// Markdown output inherits the chat's 12px scale; tables get compact GitHub-style
// borders so data answers read as data, not prose.
const components = {
  table: ({ node, ...props }) => (
    <table style={{ borderCollapse: 'collapse', width: '100%', margin: '6px 0' }} {...props} />
  ),
  th: ({ node, ...props }) => (
    <th style={{ border: '1px solid #d0d7de', padding: '4px 8px', background: '#f6f8fa', textAlign: 'left', fontWeight: 600 }} {...props} />
  ),
  td: ({ node, ...props }) => (
    <td style={{ border: '1px solid #d0d7de', padding: '4px 8px' }} {...props} />
  ),
  p: ({ node, ...props }) => <p style={{ margin: '4px 0' }} {...props} />,
  h1: ({ node, ...props }) => <div style={{ fontSize: 15, fontWeight: 700, margin: '6px 0 2px' }} {...props} />,
  h2: ({ node, ...props }) => <div style={{ fontSize: 14, fontWeight: 700, margin: '6px 0 2px' }} {...props} />,
  h3: ({ node, ...props }) => <div style={{ fontSize: 13, fontWeight: 700, margin: '6px 0 2px' }} {...props} />,
  ul: ({ node, ...props }) => <ul style={{ margin: '4px 0', paddingLeft: 18 }} {...props} />,
  ol: ({ node, ...props }) => <ol style={{ margin: '4px 0', paddingLeft: 18 }} {...props} />,
  a: ({ node, ...props }) => <a target="_blank" rel="noopener noreferrer" {...props} />,
};

/**
 * Renders assistant markdown (GitHub-flavored: tables, lists, headings). react-markdown
 * never injects raw HTML, so model output needs no additional sanitizing.
 */
export const AccentMarkdown = ({ text }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
    {(text ?? '').toString()}
  </ReactMarkdown>
);
